import * as React from 'react';
import { FastField, FieldProps } from 'formik';

interface ITextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  secondary?: boolean;
  className?: string;
}

export const Textarea = ({ className, ...props }: ITextareaProps) => (
  <textarea
    {...props}
    className={`bg-white shadow px-3 py-2 rounded-lg focus:outline-none focus:shadow-outline ${
      props.disabled ? 'opacity-50' : ''
    } ${className}`}
  />
);

const renderFormTextarea = (props: ITextareaProps) => ({
  field: { value, ...fieldProps },
}: FieldProps<any>) => (
  <Textarea id={props.name} value={value || ''} {...fieldProps} {...props} />
);

export const FormTextarea = (props: ITextareaProps) => (
  <FastField name={props.name} render={renderFormTextarea(props)} />
);



// WEBPACK FOOTER //
// ./src/components/Form/Textarea.tsx